<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/750No/tc-custom/9781466834576.jpg?1724849748152" alt="This image is the cover for the book American Craftsmen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Craftsmen
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In modern America, two soldiers will fight their way through the magical legacies of Poe and Hawthorne to destroy an undying evil—if they don't kill each other first.</b><br/><br/> US Army Captain Dale Morton is a magician soldier—a "craftsman." After a black-ops mission gone wrong, Dale is cursed by a Persian sorcerer and haunted by his good and evil ancestors. Major Michael Endicott, a Puritan craftsman, finds gruesome evidence that the evil Mortons, formerly led by the twins Roderick and Madeline, have returned, and that Dale might be one of them.<br/><br/> Dale uncovers treason in the Pentagon's highest covert ranks. He hunts for his enemies before they can murder him and Scherie, a new friend who knows nothing of his magic.<br/><br/> Endicott pursues Dale, divided between his duty to capture a rogue soldier and his desire to protect Dale from his would-be assassins. They will discover that the demonic horrors that have corrupted American magic are not bound by family or even death itself.<br/><br/> In Tom Doyle's thrilling debut, <i>American Craftsmen, </i>Seal Team Six meets ancient magic—with the fate of the United States hanging in the balance . . .<br/>   </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Doyle
      </h2>
      
      <p class="authorDescription body article"><I>The Internet Review of Science Fiction</I> has hailed TOM DOYLE's writing as "beautiful & brilliant." <I>Locus </I>Magazine  has called his stories "fascinating," "transgressive," "witty,"  "moving," and "intelligent and creepy." A graduate of the Clarion  Writing Workshop, Doyle has won the WSFA Small Press Award and third  prize in the Writers of the Future contest. He is the author of <I>American Craftsmen </I>and <I>The Left-Hand Way.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e7c722b4